import { useCallback, useEffect, useState } from 'react';
import { parseJSON } from 'src/utils/parseJSON';
import { useLocalStorage } from 'usehooks-ts';

const KEY_LOCAL_STORAGE_NUMBER_SEARCH_VISITS = 'lt-number-of-search-visits';
const KEY_SESSION_STORAGE_VISIBLE_SUBSCRIBE_MOUNTAINS =
  'lt-visible-subscribe-mountains';

const getSessionStorageKey = (): string => {
  const { pathname } = new URL(window.location.href);
  return `${KEY_SESSION_STORAGE_VISIBLE_SUBSCRIBE_MOUNTAINS}:${pathname}`;
};
/*
  Хук который управляет отображением онборда для подписки
*/
export const useShowSubscribe = (isNotShowedForce = false) => {
  const keySessionStorage = getSessionStorageKey();
  const [isShow, setIsShow] = useState(false);

  // счетчик посещения страницы поиска (показываем при 1 и 10 заходе онбординг)
  const [numberSearchVisits, setNumberSearchVisits] = useLocalStorage(
    KEY_LOCAL_STORAGE_NUMBER_SEARCH_VISITS,
    -1,
  );

  useEffect(() => {
    if (isNotShowedForce) {
      const numberSearchVisitsNew = (numberSearchVisits + 1) % 10;
      const sessionStorageValue = sessionStorage.getItem(keySessionStorage);
      const isActive = parseJSON<boolean>(sessionStorageValue);
      if (isActive === undefined) {
        setNumberSearchVisits(numberSearchVisitsNew);
        // определяем показывать ли подписку по параметру посещений
        const isShowParamVisits = numberSearchVisitsNew === 9;
        const isShown =
          (isActive === undefined || isActive) && isShowParamVisits;
        setIsShow(isShown);
        sessionStorage.setItem(keySessionStorage, JSON.stringify(isShown));
      } else {
        setIsShow(isActive);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleCloseClick = useCallback(() => {
    sessionStorage.setItem(keySessionStorage, JSON.stringify(false));
    setIsShow(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [setIsShow]);

  return {
    isShow,
    handleCloseClick,
  };
};
